import React from 'react';
import { Platform, Pressable, StyleSheet, View } from 'react-native';
import Icon from '@/components/Icon';
import Text from '@/components/Typography/Text';
import { useTheme } from '@/context/ThemeContext';
import { WORK_APPROVAL_MODES } from '@/constants/workApproval';

// Presentation only. The mounted execution owner applies and confirms a choice.
export default function WorkApprovalPanel({ mode, disabled, onChoose, children }) {
  const { colors } = useTheme();
  return <View style={styles.panel}>
    <Text size="s" weight="semibold" style={styles.heading}>When should Work check with you?</Text>
    {WORK_APPROVAL_MODES.map(option => {
      const selected = mode.id === option.id;
      const optionColor = option.id === 'full' ? colors.color_warning || '#d97706' : colors.text_color_primary;
      return <Pressable key={option.id} onPress={() => onChoose(option.id)} disabled={disabled}
        accessibilityRole="radio" accessibilityLabel={`${option.label}. ${option.description}`}
        accessibilityState={{ checked: selected, disabled }}
        {...(Platform.OS === 'web' ? { 'aria-checked': selected } : {})}
        style={({ hovered, pressed }) => [styles.option, (hovered || pressed || selected) && { backgroundColor: colors.solid_color_secondary }]}>
        <Icon name={option.icon} size={18} color={optionColor} />
        <View style={styles.copy}><Text size="s" weight="semibold" style={{ color: optionColor }}>{option.label}</Text>
          <Text size="xs" color="secondary">{option.description}</Text></View>
        <View style={styles.check}>{selected && <Icon name="check" size={14} color={optionColor} />}</View>
      </Pressable>;
    })}
    <Text size="xs" color="tertiary" style={styles.footnote}>Applies to this task. Connected folders, app access, and credit settings still apply.</Text>
    {children}
  </View>;
}

const styles = StyleSheet.create({
  panel: { padding: 8, gap: 3 },
  heading: { paddingHorizontal: 10, paddingTop: 7, paddingBottom: 9 },
  option: { flexDirection: 'row', alignItems: 'center', gap: 12, paddingHorizontal: 10, paddingVertical: 12, borderRadius: 10 },
  copy: { flex: 1, gap: 4 },
  check: { width: 16 },
  footnote: { padding: 10, paddingBottom: 6 },
});
